// Module
var code = `<div
  class="example-container {{codeBlockId}} {{methodName}} {{pageId}}"
  data-method-name="{{methodName}}"
></div>
`;
// Exports
module.exports = code;